import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import { UrlCell } from "app/components/React/Table/cells";

import { getTooltipTextForTargetUrlIcon } from "../../../edit-campaign/edit-campaign-sections/keywords/EditKeywordsTableUtils";
import { handleTargetUrlButtonIconAndColor } from "../../../infra/KeywordsCampaignsCampaignUtils";
import { transformDisplayedURL } from "../../../reports/keywords-report/shared/KeywordsReportUtils";
import { RankTrackerTooltip } from "app/components/campaigns/shared/RankTrackerTooltip";

import { Wrapper, IconButtonWrapper, WiderRankTrackerTooltip } from "./styles";
import { TargetUrlTooltipContent } from "./TargetUrlTooltipContent";

type TargetUrlCellProps = {
    site: string;
    targetUrls: string[];
    onClick: () => void;
    isButtonDisabled?: boolean;
};

export const TargetUrlCell = ({ site, targetUrls, onClick, isButtonDisabled = false }: TargetUrlCellProps) => {
    const { translate } = useTranslate();
    const displayedSite = transformDisplayedURL(site.replace("https://www.", ""));
    const siteEmpty = site === "" ? translate("rankTracker.keywordsReport.topUrl.emptyCell") : site;
    const { buttonIcon, iconColor } = handleTargetUrlButtonIconAndColor(targetUrls, siteEmpty);

    return (
        <Wrapper className="url-with-icon-cell-content">
            {site ? (
                <RankTrackerTooltip
                    theme="white"
                    placement="left"
                    content={
                        <TargetUrlTooltipContent
                            displayedSite={displayedSite}
                            targetUrls={targetUrls}
                            iconName={buttonIcon}
                            iconColor={iconColor}
                        />
                    }
                >
                    <div>
                        <UrlCell
                            site={site}
                            displayedSite={displayedSite}
                            showTooltip={false}
                        />
                    </div>
                </RankTrackerTooltip>
            ) : null}

            <IconButtonWrapper color={iconColor}>
                <WiderRankTrackerTooltip
                    enabled={!isButtonDisabled}
                    content={getTooltipTextForTargetUrlIcon(buttonIcon)}
                >
                    <IconButton
                        iconName={buttonIcon}
                        iconColor={iconColor}
                        type="flat"
                        iconSize="xs"
                        onClick={onClick}
                        width="auto"
                        height="auto"
                        isDisabled={isButtonDisabled}
                    />
                </WiderRankTrackerTooltip>
            </IconButtonWrapper>
        </Wrapper>
    );
};
